import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import { useState } from "react";
import { getUOMOptions } from "services/data.internal.service";
import { SelectField } from "ui-components/Form";
import { Fieldset } from "ui-components/Form";

import { FormTitle, Text } from "ui-components/Form";

const GrpTypeOptions = ["AMBIENT", "AIRCOND", "PALLET"]

function LocationGroupInfo({ formRender, control, errors, mode = "ADD", setValue }) {
  const [uomOptions, setUOMOptions] = useState([]);
  useQuery({
      queryKey: ["uom-options", {}],
      queryFn: () => getUOMOptions({}),
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        if (data.data) {
          const options = data.data.data.map((x) => {
            return { label: `${x.uomid}` + (x.descriptions1 ? ` - ${x.descriptions1}` : ``), value: x.uomid };
          });
          setUOMOptions(options);
        }
      },
    });

    const onWeightUOMChange = (e, option) => {
      setValue("weightUOM", option.value, { shouldDirty: true })
    }
  
    const onVolumeUOMChange = (e, option) => {
      setValue("volumeUOM", option.value, { shouldDirty: true })
    }

    const onGrpTypeChange = (e, option) => {
      setValue("locGrpType", option, { shouldDirty: true })
    }

  function renderFn(property, index, length) {
    const { size, disabled, editable, ...data } = property;
    const xs = length >= 2 ? 12/length : 12/2;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      ...(mode === "EDIT" && editable === false && { disabled: true, type: "text" }),
    };
    let renderField;
    switch (fieldProps.type) {
      case "text":
      case "number":
        renderField = <Text field={fieldProps} />;
        break;
      case "select":
        let options = [];
        let onChange = null;
        switch (data.name) {
          case "locGrpType":
            options = GrpTypeOptions;
            onChange = onGrpTypeChange;
            break;
          case "volumeUOM":
            options = uomOptions;
            onChange = onVolumeUOMChange;
            break;
          case "weightUOM":
            options = uomOptions;
            onChange = onWeightUOMChange;
            break;
        }
        renderField = <SelectField field={fieldProps} options={options} onChange={onChange} />;
        break;
    }
    return (
      <Grid key={index} item xs={xs}>
        {renderField}
      </Grid>
    )
  }

  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Location Group Information" : "Location Group Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => {
          if (rows[0].type === "fieldset") {
            return (
              <Fieldset label={rows[0].label} key={i}>
                {rows[0].fieldsetRender.map((fs_rows, fs_i) => (
                  <Grid container spacing={3} key={fs_i}>
                    {fs_rows.map((fs_row, fs_index) => renderFn(fs_row, fs_index, fs_rows.length))}
                  </Grid>
                ))}
              </Fieldset>
            );
          }
          return (
            <Grid container spacing={3} key={i}>
              {rows.map((row, index) => renderFn(row, index, rows.length))}
            </Grid>
          );
        })}
      </MDBox>
    </MDBox>
  );
}

export default LocationGroupInfo;
